const validations = {
  subdomain: {
    required: {
      value: true,
      message: 'Subdomain is required',
    },
  },
};
export default validations;
